(function($){
    'use strict';

    if($('.event-list').length) {
    	if($('.event-list .event-list__item-large').length) {
    		$('.event-list').addClass('event-list-featured');
    	}

		$('.js-event-list-more button').click(function() {
			var $button = $(this).closest('.js-event-list-more'),
				$items = $button.closest('.event-list').find('.event-list__item'),
				$hiddenItems = $items.not(':visible');


			if($hiddenItems.length < 7) {
				$button.fadeOut(300);
				$hiddenItems.fadeIn(300);
			} else {
				$hiddenItems.slice(0,6).fadeIn(300);
			}
		});

        if($('.event-list__item-ad').length) {
            if($('.event-list__item').length > 9) {
                $('.event-list__item:nth-child(8)').after($('.event-list__item-ad'));
            }
        }
    }
}(jQuery));
